import { parseMimeType } from "@scalar/helpers/http/mime-type";
import { parse, stringify } from "yaml";
//#region src/v2/blocks/request-block/helpers/structured-body-codec.ts
var jsonCodec = {
	language: "json",
	parse: (text) => JSON.parse(text),
	stringify: (value) => JSON.stringify(value, null, 2)
};
var yamlCodec = {
	language: "yaml",
	parse: (text) => parse(text),
	stringify: (value) => stringify(value)
};
var YAML_ESSENCES = /* @__PURE__ */ new Set([
	"application/yaml",
	"application/x-yaml",
	"text/yaml",
	"text/x-yaml"
]);
/**
* Return the codec for content types whose body is a structured document we can edit as
* a form (JSON and YAML families, including `+json` / `+yaml` vendor suffixes), or
* `undefined` for everything else (multipart and urlencoded keep their own form editor).
*/
var getStructuredBodyCodec = (contentType) => {
	const essence = parseMimeType(contentType).essence;
	if (essence === "application/json" || essence.endsWith("+json")) return jsonCodec;
	if (YAML_ESSENCES.has(essence) || essence.endsWith("+yaml")) return yamlCodec;
};
//#endregion
export { getStructuredBodyCodec };

//# sourceMappingURL=structured-body-codec.js.map